module.exports = __webpack_public_path__ + "static/media/logo.705b6803.png";